import analytics, { ACTION_STORE_REDIRECT_VIEW, ACTION_STORE_REDIRECT_CLICK } from '@/scripts/analytics'
import type { ActivityEnv } from './activityView'

export function createActivityViewAnalytics(): ActivityEnv['analytics'] {
  return {
    onStoreRedirectView: (hash) => analytics.sendCustomEvent(ACTION_STORE_REDIRECT_VIEW, hash),
    onStoreRedirectClick: (hash) => analytics.sendCustomEvent(ACTION_STORE_REDIRECT_CLICK, hash),
  }
}
